module.exports = __webpack_public_path__ + "static/img/echart3.3809d07a.png";